import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";

const AdkBlockTable = ({ report, onSortChange, onRemove }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} onRemove={onRemove}/>));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('date')}>Day</th>
                    <th onClick={() => onSortChange('affid')}>Affid</th>
                    <th onClick={() => onSortChange('subid')}>Subid</th>
                    <th onClick={() => onSortChange('country')}>Country</th>
                    <th onClick={() => onSortChange('impressions')}>Impressions</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkBlockTable;


// WEBPACK FOOTER //
// ./src/scenes/AdkBlock/components/Table/index.js